import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface IGlobalSearchOutput {
  clients: {
    id: number;
    picture: string | null;
    name: string;
    email: string;
  }[];
  properties: {
    id: number;
    picture: string | null;
    name: string;
  }[];
}

export interface IFetchGlobalSearchListInput {
  searchKeyWord: string;
  language: string;
}

export const fetchGlobalSearchList = async (
  payload: IFetchGlobalSearchListInput
): Promise<Types.ResponseOutput> => {
  if (payload.searchKeyWord.indexOf('+') === 0) {
    payload.searchKeyWord = payload.searchKeyWord.replace('+', '');
  }
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/globalsearch/?searchKeyWord=${payload.searchKeyWord}&language=${payload.language}`
  );

  let _data: IGlobalSearchOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
